// src/data/crisisSupport.js
// Crisis support numbers by country for Finding Your Voice (the Resources
// page). The app serves seven markets: Australia, New Zealand, India, the UK,
// Ireland, Canada and the US.
//
// ⚠️ The numbers are not kept here. They live in the fleet's one table,
// packages/crisis-support/src/services.js, with the date each was verified
// and the page it was verified on. Change a number or its hours THERE, never
// by overriding it here. This app's readers are adults, so it shows the
// 'adult' list.
//
// Until 30 September 2026 the Resources page held its own copy of six
// countries (no Ireland), with Talk Suicide Canada's retired number and
// Lifeline Aotearoa as 24/7.
//
// Imported by relative path, not a Vite alias, so the file also loads in
// plain Node (tests, and the Knowledge Hub importer).

import {
  crisisSupportTable,
  normaliseCountryKey,
  emergencyCallAdvice,
  COUNTRY_KEYS,
  DEFAULT_COUNTRY
} from '../../../../packages/crisis-support/src/index.js';

export const CRISIS_SUPPORT = crisisSupportTable('adult');

export { COUNTRY_KEYS, DEFAULT_COUNTRY, normaliseCountryKey, emergencyCallAdvice };

/**
 * Look up crisis support for a region. Fails CLOSED: an unknown or missing
 * region returns null, never another country's line.
 */
export const getCrisisSupport = (key) => CRISIS_SUPPORT[normaliseCountryKey(key)] || null;
